<div *ngIf="type =='slider'||type =='commonSlider'">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutWrap="wrap" fxLayoutAlign="start">
        <div fxFlex.gt-sm="20" fxFlex.lt-md="70" fxLayout="column" class="pr-1">
            <h4>Select files</h4>
            <div class="file-type" fxFlex.lt-md="50" ng2FileDrop (fileOver)="fileOverBase($event)"
                [uploader]="uploader">Base drop zone
            </div>
            <div class="file-type" fxFlex.lt-md="50" ng2FileDrop (fileOver)="fileOverAnother($event)"
                [uploader]="uploader">
                Another drop zone
            </div>
            <button [attr.guide]="'common-file-upload-audio-btn-1' + '__' + sanitizeUrl(url)" style="width: fit-content;" type="button" mat-raised-button (click)="file.click()">
                <mat-icon class="material-icons-outlined">cloud_upload</mat-icon>
                <span>Choose File</span>
            </button>
           <input [attr.guide]="'common-file-upload-audio-inp-files' + '__' + sanitizeUrl(url)" [autocomplete]="'off'"hidden #file type="file" name="files" ng2FileSelect [uploader]="uploader" multiple />
        </div>
        <div fxFlex.gt-sm="80" fxFlex.lt-md="100">
            <div class="pad-wrap">
                <h4 fxLayout="row">
                    <span fxFlex>Upload queue</span>
                    <span>Queue length: {{ uploader?.queue?.length }}</span>
                </h4>


                <div class="uploadTable">
                    <div class="titleHead" fxLayout="row">
                        <div class="head" fxFlex="41" >
                            <span>Filename</span>
                        </div>
                        <div class="head" fxFlex >
                            <span>Size</span>
                        </div>
                        <!-- <div class="head" fxFlex>
                            <span>Progress</span>
                        </div> -->
                        <!-- <div class="head" fxFlex="20" >
                            <span>Status</span>
                        </div> -->
                        <div class="head" fxFlex="18" >
                            <span>Action</span>
                        </div>
                    </div>
                    <div class="titleHead1" *ngFor="let row of uploader.queue let i=index" fxLayout="row">
                        <div class="head1" fxLayoutAlign="start center" fxFlex="41" >
                            <span> {{ row?.file?.name | slice:0:30 }}</span>
                        </div>
                        <div class="head1" fxLayoutAlign="start center" fxFlex >
                            <span>{{ row?.file?.size/1024/1024 | number:'.2' }} MB</span>
                        </div>
                        <!-- <div class="head1" fxLayoutAlign="start center" fxFlex>
                            <mat-progress-bar mode="determinate" value="{{row.progress}}"></mat-progress-bar>
                        </div> -->
                        <div class="head1" fxLayoutAlign="start center" fxFlex="18" >
                            <span *ngIf="uploadmsg=='File Uploaded Successfully..'">
                                <mat-icon>check</mat-icon>
                            </span>
                            <span *ngIf="row.isCancel">
                                <mat-icon>cancel</mat-icon>>
                            </span>
                            <span *ngIf="row.isError">
                                <mat-icon>delete</mat-icon>>
                            </span>
                        </div>
                        <div class="head1" fxLayoutAlign="center center" fxFlex="10" fxFlex.lt-md="25">
                            <!-- <button [attr.guide]="'common-file-upload-audio-btn-2' + '__' + sanitizeUrl(url)" mat-icon-button type="button" (click)="row.cancel()" [disabled]="!row.isUploading">
                <mat-icon>close</mat-icon>
              </button> -->
                            <button [attr.guide]="'common-file-upload-audio-btn-3' + '__' + sanitizeUrl(url)" color="warn" mat-icon-button type="button" (click)="row.remove()">
                                <mat-icon>remove_circle_outline
                                </mat-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="mrgn-b-md">
                    <p>Queue progress:</p>
                    <mat-progress-bar mode="determinate" value="{{uploader.progress}}">
                    </mat-progress-bar>
                </div>
                <div fxLayout="row" class="padding-10" fxLayoutGap="10px" fxLayout.lt-md="column"
                    fxLayoutAlign.gt-md="start center">
                    <button [attr.guide]="'common-file-upload-audio-btn-4' + '__' + sanitizeUrl(url)" fxFlex.lt-md [disabled]="text !='Upload all'" (click)="upload()" type="button" mat-raised-button>
                        <mat-icon>cloud_upload</mat-icon>
                        <span>{{text}}</span>
                        <mat-icon *ngIf="text !='Upload all' ">
                            <mat-spinner color="primary" diameter="20"></mat-spinner>
                        </mat-icon>
                    </button>
                    <!-- <button [attr.guide]="'common-file-upload-audio-btn-5' + '__' + sanitizeUrl(url)" fxFlex.lt-md mat-raised-button type="button" (click)="uploader.cancelAll()"
                        [disabled]="!uploader.isUploading">Cancel all</button> -->
                    <button [attr.guide]="'common-file-upload-audio-btn-6' + '__' + sanitizeUrl(url)" fxFlex.lt-md color="warn" mat-raised-button type="button" (click)="uploader.clearQueue()"
                        [disabled]="!uploader.queue.length">Remove all</button>
                </div>
            </div>
        </div>

    </div>
</div>

<div fxLayout="column" *ngIf="type!='slider' && type !='commonSlider'" fxLayoutGap="8px">

   <input [attr.guide]="'common-file-upload-audio-inp-7' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" type="file" #myInput hidden ng2FileSelect [uploader]="uploader"/>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <button [attr.guide]="'common-file-upload-audio-choose-7' + '__' + sanitizeUrl(url)" type="button" mat-raised-button (click)="myInput.click()">
            <mat-icon>cloud_upload</mat-icon>
            <span>Choose File</span>
        </button>
        <span class="chosen-file" fxFlex>
            {{ uploader?.queue?.length ? (uploader.queue[0]?.file?.name | slice:0:60) : 'No file chosen' }}
        </span>

        <button [attr.guide]="'common-file-upload-audio-btn-8' + '__' + sanitizeUrl(url)" [disabled]="!uploader?.queue?.length || text !='Upload all'" (click)="upload()" type="button" mat-raised-button color="primary">
            <mat-icon>cloud_upload</mat-icon>
            <span>{{text}}</span>
            <mat-icon *ngIf="text !='Upload all'">
                <mat-spinner color="primary" diameter="20"></mat-spinner>
            </mat-icon>
        </button>
    </div>

</div>
